<div class="custom-searchable-select">
<mat-select
  [value]="selectedValue"
  (selectionChange)="onSelectionChange($event.value)"
  [placeholder]="placeholder"
  class="custom-select">

  <!-- Trigger with cross button -->
  <mat-select-trigger>
    <div class="trigger-content">
      <span class="selected-text">
        {{ selectedLabel || placeholder }}
      </span>

      <button
        *ngIf="selectedValue"
        class="clear-btn"
        type="button"
        aria-label="Clear selection"
        (click)="clearSelection($event)">
        ×
      </button>
    </div>
  </mat-select-trigger>

  <!-- Search input -->
  <div class="search-container">
    <input
      type="text"
      [(ngModel)]="searchText"
      (input)="filterItems()"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      placeholder="Search..."
      class="dropdown-search-box" />
  </div>

  <!-- Filtered options -->
  <mat-option
    *ngFor="let item of filteredItems"
    [value]="item[valueKey]">
    {{ getLabel(item) }}
  </mat-option>

</mat-select>
</div>